<template>
	<v-chip-group
		:value="value"
		:column="column"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot />
	</v-chip-group>
</template>

<script>
export default {
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			default: undefined
		},
		column: {
			type: Boolean,
			default: false
		}
	}
};
</script>